<template>
  <div
    v-masonry-tile
    :class="`insight d-inline-block `"
    v-if="hasData" style="; width: 100% !important">
    <chart :options="chartOptions" style="position: relative; height: 300px" />
  </div>
  <div
    v-masonry-tile
    :class="`insight d-inline-block `"
    v-else style="; width: 100% !important">
    <div style="text-align: center; margin: auto; height: 300px; background: #3a4149;">
      <strong style="padding-top: 0; text-transform: uppercase; fontSize: 12px">{{this.title}}</strong><br/>
      <h3 style="padding: 120px 0">
        There is no data available
      </h3>
    </div>
  </div>
</template>

<script>
  import {CATEGORICAL_INSIGHT_HEIGHT} from './utils';
  import {Chart} from 'highcharts-vue';
  import {maybeMissingValueLabel, titleCase} from './utils';

  export default {
		name: 'CategoricalKeyInsight',

		components: {Chart},

    props: {
			values: Array,
			chart: String,
			plotOptions: Object,
      name: String,
      isString: Boolean,
      title: {
			  type: String,
        default: "Count"
      }
    },

    methods: {
      checkIfObject(x) {
        if ((typeof x === "object" || typeof x === 'function') && (x !== null)) {
          return true;
        }
        return false;
      }
    },

    computed: {
			hasData() {
				return this.values && this.values.length > 0;
      },

      widthColumns() {
			  // return this.values.length > 3 && this.isString ? 2 : 4;
			  return 6;
      },

			chartOptions() {
				if (!this.hasData) return {};
				if (this.values.length > 3) {
          return this.barChartOptions;
        };
				return this.pieChartOptions;
      },

			barChartOptions() {
        let xAxis = (!!this.plotOptions && this.plotOptions['xAxis']) ? this.plotOptions['xAxis'] : "";
        let categories = null;
        if ((xAxis.toLowerCase() === 'month') && (typeof this.values[0][0]) == 'number') {
          let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          // console.log(this.values[0][0], typeof this.values[0][0]);
          categories = this.values.map(point => months[point[0]-1]);
        }
        let chart = this.isString ? 'bar' : 'column';
        chart = (!!this.chart) ? this.chart : chart;
        console.log('chart', this.chart)
				return {
					chart: {
						type: chart
					},
					title: {
						text: titleCase(this.name)
					},
					xAxis: {
						categories: (!!categories) ? categories : this.values.map(bin => bin[0]),
						title: {
							text: xAxis
						},
						crosshair: true
					},
					yAxis: {
						min: 0,
						title: {
							text: (!!this.plotOptions && this.plotOptions['yAxis']) ? this.plotOptions['yAxis'] : this.title
						}
					},
					tooltip: {
						headerFormat: '',
						pointFormat: '<b>{point.y}</b>',
						footerFormat: '',
						shared: true,
						useHTML: true
					},
					plotOptions: {
						column: {
							pointPadding: 0.2,
							borderWidth: 0
						}
					},
					series: [{
						showInLegend: false,
						name: titleCase(this.name),
						data: this.values.map(point => point[1])
					}]
				};
      },

			pieChartOptions() {
				return {
					chart: {
						type: 'pie',
					},
					title: {
						text: titleCase(this.name)
					},
					tooltip: {
            pointFormatter: function() {
              var value = this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              var percentage = this.percentage.toFixed(2);
              return '<p>Amount: <b>GHS ' + value + '</b><br/>Percentage: <b>' + percentage + '%</b></p>';
            }
					},
					plotOptions: {
						pie: {
							showInLegend: true,
							allowPointSelect: true,
							cursor: 'pointer',
							dataLabels: {
								enabled: false
							}
						}
					},
					legend: {
						itemDistance: 5,
						itemStyle: {
							fontSize: '11px'
						}
					},
					series: [{
						name: titleCase(this.name),
						colorByPoint: true,
						data: this.values.map(point => ({
							name: maybeMissingValueLabel(point[0]),
							y: point[1]
						}))
					}]
				};
			}
    }
	};
</script>

<style scoped lang="sass">
  @for $i from 1 through 4
    .insight-cols-#{$i}
      width: $i * 24%
      max-width: 100%

  @media (max-width: 480px)
    @for $i from 1 through 4
      .insight-cols-#{$i}
        width: $i * 48%

  @media (max-width: 320px)
    @for $i from 1 through 4
      .insight-cols-#{$i}
        width: 96%
</style>
